import env from '../helpers/env';

// @todo can we test for this instead?

const hasAudioOutputLevelStatCapability = () => ['Chrome', 'Samsung', 'Opera', 'Safari'].indexOf(env.name) > -1;

export default hasAudioOutputLevelStatCapability;
